import { useMemo } from 'react'
import { useIntl } from 'react-intl'

export const TAB_KEYS = {
  OVERVIEW: 'overview',
  USER_PROPERTIES: 'userproperties',
  SYSTEM_USER: 'systemuser',
}

/**
 * Tabs of the user details panel: the Microsoft 365 tabs for an employee, and the System User tab for a
 * system user the viewer can manage. The edit panels reuse them so their headers match.
 */
const usePanelTabs = ({ showEmployeeTabs = false, showSystemUserTab = true } = {}) => {
  const intl = useIntl()

  return useMemo(() => {
    const tabs = []
    if (showEmployeeTabs) {
      tabs.push(
        { key: TAB_KEYS.OVERVIEW, label: intl.formatMessage({ id: 'USER_DETAILS_PANEL.OVERVIEW' }) },
        { key: TAB_KEYS.USER_PROPERTIES, label: intl.formatMessage({ id: 'USER_DETAILS_PANEL.USER_PROPERTIES' }) },
      )
    }
    if (showSystemUserTab) {
      tabs.push({ key: TAB_KEYS.SYSTEM_USER, label: intl.formatMessage({ id: 'SYSTEM_USER_PANEL.TAB' }) })
    }
    return tabs
  }, [intl, showEmployeeTabs, showSystemUserTab])
}

export default usePanelTabs
